import consumer from "./consumer"


$(document).ready(function() {

  const element = document.getElementById('room-id');
  const room_id = element ? element.getAttribute('data-room-id') : '';
  const disenoPlanilla = element ? element.getAttribute('data-prioridad-diseno') === 'planilla' : false;

  console.log('room_id: ' + room_id);

  function createSquare(p,color,vacia) {
      var detallePrioridad = document.getElementById('detalle_prioridad');

      if (disenoPlanilla) {
        var prioridad = document.createElement('div');
        var posicion = parseInt(p.replace('P', '').replace(':S', ''), 10);

        if (vacia) {
          prioridad.className = 'prioridad-envivo prioridad-envivo-vacia';
          prioridad.textContent = 'X';
        } else {
          prioridad.className = 'prioridad-envivo ' + color;
          prioridad.textContent = posicion;
        }

        if (p.endsWith(':S')) {
          prioridad.className += ' parpadeo';
        }

        detallePrioridad.appendChild(prioridad);
        return;
      }

      // Crear el div con clase "square enlinea red"
      var square = document.createElement('div');

      if (vacia) {
        square.className = 'square prioridad-vacia enlinea';
      } else if (p.endsWith(":S")) {
        //Si hay prioridad suspendida agregar clase para que parpadee
        square.className = 'square_s parpadeo enlinea '+ color;
      } else {
        square.className = 'square enlinea '+ color;
      }      

      // Crear el div interno con estilo de margen y texto "P1"
      var innerDiv = document.createElement('div');
      innerDiv.style.marginTop = '0.15rem';
      innerDiv.textContent = p.replace(':S', ' S');

      // Añadir el div interno al div "square"
      square.appendChild(innerDiv);

      // Añadir el div "square" al contenedor principal
      detallePrioridad.appendChild(square);
  };

  var prioridadesArrastrables = document.getElementById('prioridades-envivo-movil');

  if (disenoPlanilla && prioridadesArrastrables) {
    var arrastrandoPrioridades = false;
    var desplazamientoX = 0;
    var desplazamientoY = 0;
    var tamanoPrioridad = 54;
    var claveTamanoPrioridad = 'prioridades-envivo-tamano';
    var clavePosicionPrioridades = 'prioridades-envivo-posicion';
    var botonDisminuir = document.getElementById('disminuir-prioridades');
    var botonAumentar = document.getElementById('aumentar-prioridades');
    var botonPantallaCompleta = document.getElementById('pantalla-completa-prioridades');
    var botonAjustarAncho = document.getElementById('ajustar-ancho-prioridades');
    var controlesPrioridades = document.querySelector('.prioridades-envivo-controles');
    var temporizadorControles;
    var ultimaPosicionMouseX;
    var ultimaPosicionMouseY;

    function mostrarControlesPrioridades() {
      controlesPrioridades.classList.remove('ocultos');
      clearTimeout(temporizadorControles);
      temporizadorControles = setTimeout(function() {
        controlesPrioridades.classList.add('ocultos');
      }, 5000);
    }

    function registrarMovimientoMouse(event) {
      if (event.clientX === ultimaPosicionMouseX && event.clientY === ultimaPosicionMouseY) {
        return;
      }

      ultimaPosicionMouseX = event.clientX;
      ultimaPosicionMouseY = event.clientY;
      mostrarControlesPrioridades();
    }

    document.addEventListener('mousemove', registrarMovimientoMouse);
    mostrarControlesPrioridades();

    function mantenerPrioridadesEnPantalla() {
      if (window.getComputedStyle(prioridadesArrastrables).position !== 'fixed') {
        return;
      }

      var posicionActual = prioridadesArrastrables.getBoundingClientRect();
      var limiteX = Math.max(0, window.innerWidth - prioridadesArrastrables.offsetWidth);
      var limiteY = Math.max(0, window.innerHeight - prioridadesArrastrables.offsetHeight);

      prioridadesArrastrables.style.left = Math.min(Math.max(0, posicionActual.left), limiteX) + 'px';
      prioridadesArrastrables.style.top = Math.min(Math.max(0, posicionActual.top), limiteY) + 'px';
    }

    function guardarPosicionPrioridades() {
      window.localStorage.setItem(clavePosicionPrioridades, JSON.stringify({
        left: parseFloat(prioridadesArrastrables.style.left),
        top: parseFloat(prioridadesArrastrables.style.top)
      }));
    }

    function restaurarPosicionPrioridades() {
      var posicionGuardada = window.localStorage.getItem(clavePosicionPrioridades);

      if (posicionGuardada === null) {
        return;
      }

      try {
        var posicion = JSON.parse(posicionGuardada);

        if (typeof posicion.left !== 'number' || typeof posicion.top !== 'number') {
          return;
        }

        prioridadesArrastrables.style.position = 'fixed';
        prioridadesArrastrables.style.left = posicion.left + 'px';
        prioridadesArrastrables.style.top = posicion.top + 'px';
        prioridadesArrastrables.style.zIndex = '1000';
        mantenerPrioridadesEnPantalla();
      } catch (error) {
        return;
      }
    }

    function actualizarTamanoPrioridades(nuevoTamano) {
      tamanoPrioridad = Math.max(30, nuevoTamano);
      prioridadesArrastrables.style.setProperty('--tamano-prioridad', tamanoPrioridad + 'px');
      prioridadesArrastrables.style.setProperty('--fuente-prioridad', Math.round(tamanoPrioridad * 0.59) + 'px');
      prioridadesArrastrables.style.setProperty('--espacio-prioridad', Math.max(6, Math.round(tamanoPrioridad * 0.22)) + 'px');
      window.localStorage.setItem(claveTamanoPrioridad, tamanoPrioridad.toString());
      botonDisminuir.disabled = tamanoPrioridad === 30;
      botonAumentar.disabled = false;
      mantenerPrioridadesEnPantalla();
    }

    function ajustarPrioridadesAlAncho() {
      var listaPrioridades = document.getElementById('detalle_prioridad');
      var cantidadPrioridades = listaPrioridades.querySelectorAll('.prioridad-envivo').length;

      if (cantidadPrioridades === 0) {
        return;
      }

      var estilosLista = window.getComputedStyle(listaPrioridades);
      var rellenoHorizontal = parseFloat(estilosLista.paddingLeft) + parseFloat(estilosLista.paddingRight);
      var anchoDisponible = window.innerWidth - rellenoHorizontal;
      var nuevoTamano = Math.max(30, Math.floor(anchoDisponible / cantidadPrioridades));
      var espacio = Math.max(6, Math.round(nuevoTamano * 0.22));

      while (nuevoTamano > 30 && nuevoTamano * cantidadPrioridades + espacio * (cantidadPrioridades - 1) > anchoDisponible) {
        nuevoTamano -= 1;
        espacio = Math.max(6, Math.round(nuevoTamano * 0.22));
      }

      prioridadesArrastrables.style.position = 'fixed';
      prioridadesArrastrables.style.left = '0px';
      prioridadesArrastrables.style.top = '0px';
      prioridadesArrastrables.style.zIndex = '1000';
      actualizarTamanoPrioridades(nuevoTamano);
      prioridadesArrastrables.style.top = Math.max(0, (window.innerHeight - prioridadesArrastrables.offsetHeight) / 2) + 'px';
      guardarPosicionPrioridades();
    }

    ajustarPrioridadesAlAncho();

    botonDisminuir.addEventListener('click', function() {
      actualizarTamanoPrioridades(tamanoPrioridad - 8);
    });

    botonAumentar.addEventListener('click', function() {
      actualizarTamanoPrioridades(tamanoPrioridad + 8);
    });

    botonPantallaCompleta.addEventListener('click', function() {
      if (document.fullscreenElement) {
        document.exitFullscreen();
      } else {
        document.documentElement.requestFullscreen();
      }
    });

    botonAjustarAncho.addEventListener('click', ajustarPrioridadesAlAncho);

    prioridadesArrastrables.addEventListener('pointerdown', function(event) {
      if (!event.target.closest('.prioridad-envivo')) {
        return;
      }

      var posicionActual = prioridadesArrastrables.getBoundingClientRect();

      prioridadesArrastrables.style.position = 'fixed';
      prioridadesArrastrables.style.left = posicionActual.left + 'px';
      prioridadesArrastrables.style.top = posicionActual.top + 'px';
      prioridadesArrastrables.style.zIndex = '1000';

      desplazamientoX = event.clientX - posicionActual.left;
      desplazamientoY = event.clientY - posicionActual.top;
      arrastrandoPrioridades = true;
      prioridadesArrastrables.classList.add('arrastrando');
      prioridadesArrastrables.setPointerCapture(event.pointerId);
      event.preventDefault();
    });

    prioridadesArrastrables.addEventListener('pointermove', function(event) {
      if (!arrastrandoPrioridades) {
        return;
      }

      var limiteX = Math.max(0, window.innerWidth - prioridadesArrastrables.offsetWidth);
      var limiteY = Math.max(0, window.innerHeight - prioridadesArrastrables.offsetHeight);
      var posicionX = Math.min(Math.max(0, event.clientX - desplazamientoX), limiteX);
      var posicionY = Math.min(Math.max(0, event.clientY - desplazamientoY), limiteY);

      prioridadesArrastrables.style.left = posicionX + 'px';
      prioridadesArrastrables.style.top = posicionY + 'px';
    });

    function finalizarArrastre(event) {
      if (!arrastrandoPrioridades) {
        return;
      }

      arrastrandoPrioridades = false;
      prioridadesArrastrables.classList.remove('arrastrando');

      if (prioridadesArrastrables.hasPointerCapture(event.pointerId)) {
        prioridadesArrastrables.releasePointerCapture(event.pointerId);
      }

      guardarPosicionPrioridades();
    }

    prioridadesArrastrables.addEventListener('pointerup', finalizarArrastre);
    prioridadesArrastrables.addEventListener('pointercancel', finalizarArrastre);
  }


  if (room_id != '' ){

    window.prioridadSubscription = consumer.subscriptions.create({channel: "PrioridadChannel", room:room_id},{
      connected() {
        // Called when the subscription is ready for use on the server
        console.log("Conectado al prioridad channel..." + room_id)
        
      },

      disconnected() {
        // Called when the subscription has been terminated by the server
      },

      received(data) {
        // Called when there's incoming data on the websocket for this channel
        var datajson = JSON.parse(data);
        var detallePrioridad = document.getElementById('detalle_prioridad');
        var fondo_prioridad = document.getElementById('fondo_prioridad');

        document.dispatchEvent(new CustomEvent('prioridades:actualizadas', { detail: datajson }));

        if (detallePrioridad === null || fondo_prioridad === null) {
          return;
        }

        //Borrar las proiridades anteriores
        while (detallePrioridad.firstChild) {
            detallePrioridad.removeChild(detallePrioridad.firstChild);
        }

        //Crear los div con las nuevas prioridades
        var cont = 0;
        var numPrioridades = parseInt(element.getAttribute('data-num-prioridades'), 10);

        if (numPrioridades > 0) {
          for (var posicion = 1; posicion <= numPrioridades; posicion += 1) {
            var claveSuspendida = posicion + ':S';
            var clave = datajson[claveSuspendida] ? claveSuspendida : posicion.toString();
            createSquare('P' + clave, datajson[clave], !datajson[clave]);
            cont += 1;
          }
        } else {
          for (var key in datajson) {
            cont = cont + 1;
            createSquare("P"+key, datajson[key], false);
          }
        }

        //ajustar el ancho del fondo gris al número de prioridades
        if (cont >0 ){
          $("#con_sin_prioridades").removeClass("ocultar");
          if (!disenoPlanilla) {
            var wdt = cont*37
            fondo_prioridad.style.width = wdt+'px';
          }
        }
        else {
          $("#con_sin_prioridades").addClass("ocultar");
        }

      }
    });

  }


    
});
